import { WebPcmRecorder } from '../audio';
import { WebTranslationEngine } from './mt';
import { OnDeviceWebSpeechRecognizer, WhisperWebRecognizer } from './stt';
import { WebSpeechSynthesizer } from './tts';

/**
 * One instance of each engine for the whole app.
 *
 * Models are expensive to load and expensive in memory — a second copy of
 * Whisper would roughly double the footprint, which on a phone is the
 * difference between working and having the tab killed. Both the translator
 * screen and the diagnostics harness share these.
 */
export const recorder = new WebPcmRecorder();

/**
 * The microphone is handed back whenever this app is not in front.
 *
 * Wired here rather than in a component because it is a property of the one
 * recorder that exists, not of whichever screen happens to be mounted — the
 * translator can unmount while a stream is still open, and the device must be
 * released either way.
 */
recorder.installLifecycleRelease();
export const whisper = new WhisperWebRecognizer();
export const webSpeech = new OnDeviceWebSpeechRecognizer();
export const mt = new WebTranslationEngine();
export const tts = new WebSpeechSynthesizer();
